<template>
  <div :class="'bs-page' + contentClass">
    <el-row
      v-if="isLoading !== true"
      :element-loading-background="
        loading.background || this.$loadingDefault.background
      "
      :element-loading-text="loading.text || this.$loadingDefault.text"
      v-loading="loading.display"
    >
      <slot name="header"></slot>
      <slot v-if="result.data.length > 0" name="data" :data="result.data"></slot>
      <slot v-else-if="loading.display !== true" name="empty"></slot>
      <slot name="paging" :data="result.paging"></slot>
      <slot name="footer"></slot>
    </el-row>
    <template v-else>
      <slot name="header"></slot>
      <slot v-if="result.data.length > 0" name="data" :data="result.data"></slot>
      <slot v-else-if="loading.display !== true" name="empty"></slot>
      <slot v-if="result.data.length > 0" name="paging" :data="result.paging"></slot>
      <slot name="footer"></slot>
    </template>
  </div>
</template>

<style scoped lang="scss"></style>

<script>
import { getElongPage } from "../actions/basis/page";
import { getHotelPage } from "../actions/basis/page";
import { debuglog } from "util";
export default {
  data() {
    return {
      loading: {
        display: false,
        background: null,
        text: null
      },
      result: {
        data: [],
        paging: {
          totalCount: 0
        }
      }
    };
  },
  name: "BsElHotelPage",
  props: {
    routeWatch: {
      type: Boolean,
      default: true
    },
    meta: {
      type: Object,
      module: {
        type: String,
        required: true
      },
      field: {
        type: String,
        required: true
      }
    },
    filter: {
      type: Object
      // pageIndex:1,
      // pageSize:20
    },
    api: {
      type: String
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    contentClass: {
      type: String
    },
    isInit: {
      type: Boolean,
      default: true
    }
  },
  computed: {},
  components: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    if (this.isInit) {
      this.loadData();
    }
    //父窗口使用 that.$refs["ref"].loadData();
  },
  methods: {
    clearData() {
      this.result.data = [];
    },
    loadData(reset) {
      let that = this;
      that.loading.display = true;
      if (this.isLoading === true) {
        that.$emit("on-load-before", that.loading.display);
      }
      that.result.data = [];
      if (that.result.paging && reset) {
        that.result.paging.totalCount = 0;
      }
      that.params = {
        arrivalDateField: this.filter.arrivalDateField,
        departureDateField: this.filter.departureDateField,
        cityIdField: "1411",
        pageIndexField: this.filter.pageIndex,
        pageSizeField: this.filter.pageSize,
        resultTypeField: "1,2,3,4,8"
      };

      // getElongPage(that.filter,{}).then(
      //   res => {
      //     that.loading.display = false;
      //     if (this.isLoading === true) {
      //       that.$emit("on-load-after", that.loading.display);
      //     }
      //     if (!res) return;
      //     that.result.data = res.Result;
      //     that.result.pageCount = res.Result.countField;
      //     that.result.pageIndex = 1;
      //     that.result.pageSize = 16;
      //     that.$emit("on-data-after", that.result);
      //   }
      // );

      // debugger
      let data = JSON.stringify(that.params);
      $.ajax({
        type: "post",
        dataType: "json",
        contentType: "application/json",
        url: "http://hotelapi.whlyw.net/api/Elong/GetHotelList",
        data: data,
        cache: true,
        async: true, //异步
        crossDomain: true,
        success: function(res) {
          //debugger
          that.loading.display = false;
          if (this.isLoading === true) {
            that.$emit("on-load-after", that.loading.display);
          }
          if (!res) return;

          that.result.data = res.Result.hotelsField;
        //   debugger
          if (!that.result.data) {
            // this.$message.warning("暂无数据");
            // alert("暂无数据");
            that.result.data = [];
            return;
          } else {
            that.result.paging.totalCount = res.Result.countField;
          }
          that.$emit("on-data-after", that.result);
          // console.log(that.result.data)
        }
      });
    }
  },
  watch: {
    $route: function(to, from) {
      if (this.routeWatch === true) {
      }
    }
  },
  destroyed() {},
  deactivated() {}
};
</script>
